<div
	class="w-full h-full bg-white rounded-xl flex-col flex items-stretch gap-4 pb-4 pt-6 overflow-hidden border-grey-lighter border"
	data-intercom-target="template-sidebar"
>
	<h3 class="px-4">Add From Template</h3>

	<hr />

	<div
		class="flex flex-col flex-1 gap-2 items-stretch overflow-hidden p-1 -mx-1"
	>
		<app-input
			[startIcon]="ICON.SEARCH"
			class="flex-none px-4"
			placeholder="Search templates..."
			[(ngModel)]="documentFilter"
			(ngModelChange)="filterDocuments()"
		></app-input>

		<ng-container *ngIf="filteredBusinessDocuments?.length; else noDocuments">
			<div class="flex items-center justify-center text-grey text-sm w-full">
				{{ filteredBusinessDocuments?.length }} Templates
			</div>

			<ul
				class="flex flex-col items-stretch flex-1 h-0 overflow-y-auto overflow-x-hidden text-sm"
			>
				<li
					class="hover:bg-gray-100 cursor-pointer py-4 px-2.5 flex gap-2.5 group first:border-t border-b border-grey-lighter text-grey-darker w-full transition-all"
					*ngFor="let doc of filteredBusinessDocuments"
					(click)="createDocument(doc)"
				>
					<app-icon [icon]="ICON.DOCUMENT"></app-icon>
					<div class="flex flex-col flex-1">
						<div>{{ doc.title }}</div>
						<div *ngIf="doc.groupType" class="text-grey text-xs">
							{{ friendlyGroupTypes[doc.groupType] }}
						</div>
					</div>
				</li>
			</ul>
		</ng-container>
		<ng-template #noDocuments>
			<div class="flex flex-col text-center text-grey px-2.5">
				<div class="font-bold">No results</div>
				<div>Sorry, there are no templates that match your search term.</div>
			</div>
		</ng-template>
	</div>

	<div class="flex-col flex items-stretch gap-4 px-4">
		<app-button
			cssClasses="button w-full"
			(onClick)="goToManageTemplates()"
			data-intercom-target="manage-templates-btn"
			>Manage templates</app-button
		>
		<div class="text-center">
			<a
				class="request-custom-template-link"
				class="bot-trigger--feedback text-green hover:text-green-hover underline cursor-pointer"
				data-intercom-target="request-custom-template-link"
			>
				Request a custom template
			</a>
		</div>
	</div>
</div>
